<template>
  <v-container v-if="dashboardMessages && dashboardMessages.length > 0">
    <v-card v-for="message in dashboardMessages" v-bind:key="message">
      <v-card-text v-html="message" />
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "dashboard-message",

  props: {},
  computed: {
    dashboardMessages() {
      if (window.systemData && window.systemData.dashboardMessage)
        return window.systemData.dashboardMessage;
      else return [];
    },
  },
  data() {
    return {};
  },
  methods: {},

  mounted() {},
  watch: {},
};
</script>